import React from 'react';
import Fetch from '@components/util/Fetch';
import Icon from '@components/shared/icons';
import { logCrmEvent } from '../../util/eventLogging';
import PropTypes from 'prop-types';

import {
  formatDollars,
  redirectTo,
} from '@components/util/helpers';
import './styles.scss';

function redirectToAccountSettings() {
  logCrmEvent('prime_reactivate_banner_click');
  redirectTo('/profile/account-settings/prime?reactivate=true');
}

function ReactivationPrimeBanner({ data }) {
  const {
    activePrime,
    lifetimeEarnings,
    lifetimeClosings,
    pendingCancelPrime,
    dismissPath
  } = data;

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const banner = document.getElementById('prime-reactivation-banner');
    banner.style.display = 'none';
    Fetch.post({ url: dismissPath });
  };

  return (
    <div
      id="prime-reactivation-banner"
      role="button"
      onClick={redirectToAccountSettings}
    >
      <button
        type="button"
        className="close-reactivation-button"
        onClick={handleClose}
      >
        <Icon type="close" />
      </button>

      <span className="reactivation-text large-bold-font">
        {pendingCancelPrime && !lifetimeClosings
          ? (
            <>
              <Icon type="chart-down" />
              Your lead volume will significantly drop once your PRIME subscription ends. Reactivate today to avoid missing out on referrals in your area!
            </>
          )
          : lifetimeEarnings && lifetimeEarnings > 0
          ? (
            <>
              <Icon type="trophy" />
              {`You've made ${formatDollars(lifetimeEarnings)} in Lifetime Earnings. Don't miss out on future opportunities and reactivate today!`}
            </>
          )
          : (
            <>
              <Icon type="chart-down" />
              Since leaving PRIME, your referral volume has significantly dropped. Don't miss out on future opportunities and reactivate today!
            </>
          )
        }
      </span>
      <button
        type="button"
        className="profile-edit-button submit"
      >
        {
          activePrime
            ? 'Reactivate PRIME'
            : 'Rejoin PRIME'
        }
      </button>
    </div>
  );
}


ReactivationPrimeBanner.propTypes = {
  data: PropTypes.shape({
    activePrime: PropTypes.bool,
    lifetimeEarnings: PropTypes.number,
    lifetimeClosings: PropTypes.number,
    pendingCancelPrime: PropTypes.bool,
    dismissPath: PropTypes.string,
  }).isRequired,
};

export default ReactivationPrimeBanner;
